import React from 'react';
import styles from '../styles/TeaConnoisseurSection.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const TeaConnoisseurSection = () => (
  <section className={styles.section} aria-labelledby="tea-connoisseur-title">
    <div className={styles.imagePanel}>
      <img
        src={`${publicUrl}/images/tea/mursalski-tea.webp`}
        alt="Selected loose-leaf tea blend"
        loading="lazy"
        decoding="async"
      />
    </div>
    <div className={styles.copy}>
      <p className={styles.eyebrow}>За ценители</p>
      <h2 id="tea-connoisseur-title" className={styles.displayTitle}>Чай с характер</h2>
      <p>
        Подбрани билки, цветя и редки смеси за хората, които обичат да
        откриват нови аромати. Всяка чаша носи свой ритъм — от свежо начало
        до бавен, спокоен финал.
      </p>
      <h3 className={styles.displayTitle}>ЧАЯТ</h3>
      <p>
        е онази специална напитка, която още с първата си глътка може да те
        отведе на пътешествие в чудни светове от аромат и вкус, да те пренесе
        от континент на континент и от епоха в епоха, дори днес, когато не
        можеш да пътуваш свободно.
      </p>
      <p>
        Чаят има силата да излекува тялото ти и да успокои или събуди ума ти.
        Той носи в себе си хиляди усмивки и блажени въздишки.
      </p>
    </div>
    <div className={styles.imagePanel}>
      <img
        src={`${publicUrl}/images/tea/tea-cup.webp`}
        alt="Steaming cup of tea"
        loading="lazy"
        decoding="async"
      />
    </div>
  </section>
);

export default TeaConnoisseurSection;
